var parent = require('../../es/object/get-own-property-names');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/get-own-property-names.js
// module id = 999
// module chunks = 0